import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {PriceLevelEntityModel} from "../price-level-entity.model";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";
import {
    PriceLevelScheduleEditPageComponent
} from "../../price-level-schedule/price-level-schedule-edit-page/price-level-schedule-edit-page.component";
import {PricingScheduleSummaryData} from "../../pricing-schedule/pricing-schedule.data"
import {
    FUIAlertAction,
    FUIAlertActions,
    FUIAlertService,
    FUIResponsiveService,
    FUISpinnersService
} from "@fedeltapointofsale/ui";
import {
    PriceLevelScheduleDiscontinueAction,
    PriceLevelScheduleDiscontinueService
} from "../price-level-schedule-discontinue.service";
import {
    DiscontinueSearchActionComponent
} from "../../../framework/common-controls/actions/discontinue-search-action.component";
import {PriceLevelScheduleSummaryData} from "../price-level.data";
import {Markup_Type, Markup_Value_Type, MarkupData} from "../../markup/markup.data";

@Component({
    selector: "wbo-price-level-edit-page",
    templateUrl: "./price-level-edit-page.component.html",
    providers: [
        provideEntityModel(PriceLevelEntityModel),
        PriceLevelScheduleDiscontinueService
    ]
})
export class PriceLevelEditPageComponent extends AbstractEditPage {
    EditMode = EditMode;
    PriceLevelScheduleEditPageComponent = PriceLevelScheduleEditPageComponent;
    PricingScheduleSummaryData = PricingScheduleSummaryData;
    Markup_Type = Markup_Type;

    constructor(public model: PriceLevelEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService,
                private priceLevelScheduleDiscontinueService: PriceLevelScheduleDiscontinueService,
                private spinnersService: FUISpinnersService,
                private alertService: FUIAlertService) {
        super(changeDetectorRef, responsiveService);
    }

    getMarkupNotation(): string {
        const markupValueType: Markup_Value_Type = MarkupData.getValueType(this.model.data.modifier.type);
        return markupValueType == Markup_Value_Type.CURRENCY ? "wbo.common.currencyCode" :
            markupValueType == Markup_Value_Type.PERCENT ? "wbo.common.percent" :
                "wbo.common.empty";
    }

    async discontinueSchedule(priceLevelScheduleSummary: PriceLevelScheduleSummaryData): Promise<void> {
        const action: FUIAlertAction = await this.alertService.showConfirmationOkCancel(DiscontinueSearchActionComponent.title, DiscontinueSearchActionComponent.message)
            .toPromise();
        if (action === FUIAlertActions.OK_ACTION) {
            this.spinnersService.open(true);
            try {
                await this.priceLevelScheduleDiscontinueService.performAction(new PriceLevelScheduleDiscontinueAction(priceLevelScheduleSummary.priceLevelScheduleId));
                priceLevelScheduleSummary.discontinued = true;
            } finally {
                this.spinnersService.close();
            }
        }
    }

    scheduleRowRemovable(rowIndex: number, priceLevelScheduleSummaryData: PriceLevelScheduleSummaryData): boolean {
        return !priceLevelScheduleSummaryData.discontinued;
    }
}
